module.exports = __webpack_public_path__ + "img/bab1t3.d5122a2e.png";